import React from "react";
import {
  Chart as ChartJS,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Title,
  Filler,
  CategoryScale,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  Filler,
  Title
);

interface GraphViewProps {
  labels: string[];
  dataPoints2023: number[];
  dataPoints2024: number[];
}

const GraphView: React.FC<GraphViewProps> = (props) => {
  // PROPS
  const { labels, dataPoints2023, dataPoints2024 } = props;

  const data = {
    labels,
    datasets: [
      {
        label: "Views 2023",
        data: dataPoints2023,
        fill: false,
        borderColor: "lightgreen",
        pointBackgroundColor: "#ffffff",
        pointBorderColor: "#fff",
        pointRadius: 2,
        pointHoverRadius: 7,
        tension: 0.5,
      },
      {
        label: "Views 2024",
        data: dataPoints2024,
        fill: true,
        backgroundColor: "rgba(0, 128, 0, 0.4)",
        borderColor: "green",
        pointBackgroundColor: "green",
        pointBorderColor: "#fff",
        pointRadius: 2,
        pointHoverRadius: 7,
        tension: 0.5,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: "Views Over Time",
        color: "#333",
        font: { size: 16 },
      },
    },
    elements: {
      point: {
        hoverBackgroundColor: "#00be5f",
        hoverBorderColor: "#fff",
        hoverBorderWidth: 2,
        hoverRadius: 7,
      },
    },
    onHover: (event: React.MouseEvent, chartElement: any) => {
      const pointHovered = chartElement[0];
      event.native.target.style.cursor = pointHovered ? "pointer" : "default";
    },
    scales: {
      x: {
        grid: {
          display: false, // Remove x-axis grid lines
          drawBorder: true,
        },
        ticks: {
          display: true, // Show x-axis values
        },
      },
      y: {
        position: "left", // Move y-axis to left
        grid: {
          display: false, // Remove y-axis grid lines
          drawBorder: false, // Remove y-axis line
        },
        ticks: {
          display: true, // Show y-axis values
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div>
      <Line data={data} options={options} height={260} />
    </div>
  );
};

export default GraphView;
